<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>FENSTERBÄNKE AUS NATURSTEIN</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Die Zeiten in denen Fensterbänke lediglich dazu dienten, das Wasser ablaufen zu lassen, sind lange vorbei! Mit einer Fensterbank aus Naturstein setzen Sie im Innenbereich einen stylischen Akzent in jedem Raum. Im Außenbereich verbinden Natursteinfensterbänke Ästhetik und Funktionalität gleichermaßen. Sie sind ein echter Hingucker und zudem auch noch extrem widerstandsfähig, frostsicher, langlebig und pflegeleicht.</p>
        <hr>
        <h2>Unser Plus beim Verlegen Ihrer Natursteinfensterbank</h2>
        <p>Bei uns erhalten Sie hochwertige Natursteinfensterbänke! Ob Marmor, Granit oder Schiefer - wir haben Ihre Fensterbank, die wir individuell nach Maß anfertigen und gerne auch um Details wie Abtropfrinnen ergänzen. <router-link :to="{ name: 'Kontakt' }">Vereinbaren Sie einen Beratungstermin mit uns!</router-link></p>
        <hr>
        <div class="image-row">
      <div class="image-row-item" ><img src="https://marmor-kunze.de/static/portfolio/fensterbaenke/fensterbank001.jpg"></div>
      <div class="image-row-item" ><img src="https://marmor-kunze.de/static/portfolio/fensterbaenke/fensterbank002.jpg"></div>
      <div class="image-row-item" ><img src="https://marmor-kunze.de/static/portfolio/fensterbaenke/fensterbank003.jpg"></div>
        </div>
        <!-- <button type="button" @click="show">Show</button> -->
      </article>
    </div>
    </section>
</template>

<script>
export default {
  name: 'Fensterbaenke',
   metaInfo: {
    title: 'Fensterbänke aus Naturstein',
    meta:[
      { vmid: 'description', name: 'description', content: "Fensterbänke aus Naturstein setzen im Innenbereich stylische. Im Außenbereich verbinden Natursteinfensterbänke Ästhetik und Funktionalität gleichermaßen. "},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein Fensterbank, Granit Fensterbank, Marmor Fensterbank, Natursteinfensterbank, Granitfensterbank, Marmorfensterbank,Natursteinfensterbank Mönchengladbach, Naturstein Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/naturstein-fensterbank'} ]
  },
  methods: {
     /*  show () {
        const viewer = this.$el.querySelector('image-row-item').$viewer
        viewer.show()
      } */
    }
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Fensterbaenke.vue